import { render, staticRenderFns } from "./TenantsSelect.vue?vue&type=template&id=0fd5c8f1"
import script from "./TenantsSelect.vue?vue&type=script&lang=js"
export * from "./TenantsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports